/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import './components/DropdownItem.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import SignatureServices from './components/SignatureServices';
import AdmissionsOverview from './components/AdmissionsOverview';
import Contact from './components/Contact';
import Boarding from './components/Boarding';
import Philosophy from './components/Philosophy';
import PrimusMentorship from './components/PrimusMentorship';
import PassionProject from './components/PassionProject';
import CyberSmart from './components/CyberSmart';
import Mothercare from './components/Mothercare';
import MentorArc from './components/MentorArc';
import Siemens from './components/Siemens';
import Team from './components/Team';
import { LanguageProvider, useLanguage } from './hooks/useLanguage';

const DropdownItem: React.FC<{
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  showBorder?: boolean;
  thinner?: boolean;
}> = ({ href, onClick, children, showBorder = true, thinner = false }) => {
  const className = `dropdown-item ${thinner ? 'thinner' : ''}`;

  if (href) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    );
  }
  
  return (
    <a onClick={onClick} className={className}>
      {children}
    </a>
  );
};

function AppContent() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleDropdownClick = (path: string) => {
    navigate(path);
    setIsDropdownOpen(false);
  };

  return (
    <div className="App">
      {/* Invisible bridge to prevent flickering - only active when dropdown is open */}
      {isDropdownOpen && (
        <div
          onMouseEnter={() => setIsDropdownOpen(true)}
          onMouseLeave={() => setIsDropdownOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: 'calc(50% + 100px)',
            height: '250px',
            zIndex: 998,
            backgroundColor: 'transparent',
            pointerEvents: 'auto'
          }}
        />
      )}
      <div 
        onMouseEnter={() => setIsDropdownOpen(true)}
        onMouseLeave={() => setIsDropdownOpen(false)}
        style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '250px',
        backgroundColor: 'rgba(245, 245, 245, 0.45)',
        backdropFilter: 'blur(2px)',
        zIndex: 999,
        display: 'block',
        opacity: isDropdownOpen ? 1 : 0,
        visibility: isDropdownOpen ? 'visible' : 'hidden',
        transition: 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out',
        paddingTop: '90px'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          marginLeft: 'calc(50% - 362px)'
        }}>
          <DropdownItem onClick={() => handleDropdownClick('/admissions-overview')} showBorder={false}>
            {t('admissions.title')}
          </DropdownItem>
          <DropdownItem onClick={() => handleDropdownClick('/signature-services')} showBorder={false} thinner={true}>
            {t('services.title')}
          </DropdownItem>
          <DropdownItem onClick={() => handleDropdownClick('/primus-mentorship')} showBorder={false} thinner={true}>
            {t('mentorship.title')}
          </DropdownItem>
          <DropdownItem onClick={() => handleDropdownClick('/boarding')} showBorder={false}>
            {t('boarding.title')}
          </DropdownItem>
        </div>
      </div>
      <Header onConsultingHover={setIsDropdownOpen} isDropdownOpen={isDropdownOpen} />
      <div className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/signature-services" element={<SignatureServices />} />
            <Route path="/admissions-overview" element={<AdmissionsOverview />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/boarding" element={<Boarding />} />
            <Route path="/philosophy" element={<Philosophy />} />
            <Route path="/primus-mentorship" element={<PrimusMentorship />} />
            <Route path="/passion-project" element={<PassionProject />} />
            <Route path="/cybersmart" element={<CyberSmart />} />
            <Route path="/mothercare" element={<Mothercare />} />
            <Route path="/mentorarc" element={<MentorArc />} />
            <Route path="/siemens" element={<Siemens />} />
            <Route path="/team" element={<Team />} />
          </Routes>
        </div>
        <Footer />
      </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
        <Analytics />
      </Router>
    </LanguageProvider>
  );
}

export default App;